import type {
    PlayerMeta,
    PlayerMetaFilm,
    PlayerMetaEpisode,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function checkIsTvSeries(typename?: string) {
    return typename === 'TvSeries' || typename === 'MiniSeries' || typename === 'TvShow';
}

interface Title {
    localized: string | null;
    original: string | null;
}

export function presentTitle(title: Title | undefined): string | undefined {
    return title?.localized ?? title?.original ?? undefined;
}

export const isFilmPlayerMeta = (
    playerMeta: PlayerMeta | undefined
): playerMeta is PlayerMetaFilm => playerMeta?.typename === 'Film';

export const isEpisodePlayerMeta = (
    playerMeta: PlayerMeta | undefined
): playerMeta is PlayerMetaEpisode => playerMeta?.typename === 'Episode';
